
<div *ngIf="activeLoading">
  <div class="lds-all rbInitialLoader align-load" fxLayout="row" fxLayoutAlign="center center" *ngIf="color">
      <div class="lds-rolling align-load" fxLayout="row" fxLayoutAlign="center center">
          <mat-spinner [diameter]="25" [ngStyle]="spinnerStyle"></mat-spinner>
          <h1 [style.color]="color">Carregando...</h1>
      </div>
  </div>
</div>
